import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { API_URL } from '../config';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session data
        const response = await axios.post(`${API_URL}/auth/google/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        if (response.data.status === 'success') {
          setGoogleUser(response.data.user);
          // Navigate to dashboard with user data to skip auth check
          navigate('/dashboard', { 
            replace: true, 
            state: { user: response.data.user } 
          });
        } else {
          throw new Error('Session exchange failed');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, setGoogleUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-mint">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" style={{ width: 40, height: 40 }} />
        <p className="text-muted-foreground">Accesso in corso...</p>
      </div>
    </div>
  );
}
